import React from "react";
import Menubar from "./Menubar";
import { useHistory } from "react-router-dom";

function Main() {
  const history = useHistory();

  function clickHandler(id) {
    history.push(`/${id}`);
  }

  return (
    <div className="body">
      <Menubar />
      <div className="hero">
        <h1>Money Heist</h1>
        <button onClick={e => clickHandler(569470745)}>Watch Now</button>
      </div>
    </div>
  );
}

export default Main;
